import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';

const FullSpecsLink = ({ isMobile }) => {
	const [detailedSpecsAvailable, setDetailedSpecsAvailable] = useState(false);
	const desktopOffset = 75;
	const mobileOffset = 5;
	const detailedSpecsSelector = '[data-widget-name="ws-detailed-specs"]';
	const headerSelector = '.page-header';

	const labels = useLabels();
	const buttonLabel = labels.get('QUICK_SPECS_VIEW_FULL_SPECS');

	const clickHandler = () => {
		const headerEl = document.querySelector(headerSelector);
		const detailedSpecsEl = document.querySelector(detailedSpecsSelector);
		const extraOffset = isMobile ? mobileOffset : desktopOffset;
		const headerOffset =
			headerEl?.getBoundingClientRect().bottom + extraOffset || 0;
		const yOffset = -headerOffset;
		const yPosition =
			detailedSpecsEl.getBoundingClientRect().top +
			window.scrollY +
			yOffset;
		const dsWidgetId = detailedSpecsEl.getAttribute('data-widget-id');

		// Scroll To DetailedSpecs
		window.scrollTo({ top: yPosition, behavior: 'smooth' });

		// Expand DetailedSpecs (on mobile)
		$(`#${dsWidgetId}-collapse`).collapse('show');

		// Expand Inner Specs
		const pubsub = window?.DDC?.pubsub;
		if (pubsub) {
			pubsub.publish('ws-detailed-specs_expand');
		}
	};

	useEffect(() => {
		const detailedSpecsEl = document.querySelector(detailedSpecsSelector);
		if (detailedSpecsEl) {
			setDetailedSpecsAvailable(true);
		}
	}, []);

	if (!detailedSpecsAvailable) {
		return null;
	}

	return (
		<button
			type="button"
			className="text-nowrap unstyled-button ddc-font-size-xsmall mr-2 text-link"
			onClick={clickHandler}
		>
			<span className="d-flex flex-row align-items-center py-1">
				<span className="mr-2">{buttonLabel}</span>
			</span>
		</button>
	);
};

FullSpecsLink.propTypes = {
	isMobile: PropTypes.bool
};

export default FullSpecsLink;
